import { useSnackbar } from "notistack";

import { useTranslation } from "react-i18next";
import { useRemoveGroupMutation } from "../recipientsApiSlice";

export const RemoveGroup = ({ count, groupId, setActiveTab }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [removeGroup, { isLoading }] = useRemoveGroupMutation();

	const handleRemove = async () => {
		if (count > 0) {
			enqueueSnackbar(t("removing_groups_with_contact_not_allowed"), {
				variant: "error",
				preventDuplicate: true,
			});
			return;
		}

		await removeGroup({ groupId })
			.unwrap()
			.then(() => {
				enqueueSnackbar(t("removed_group"), {
					variant: "success",
				});
				setActiveTab(0);
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([_key, message]) => {
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<button
			onClick={handleRemove}
			style={{
				background: "transparent",
				border: "none",
				borderBottom: "1px solid red",
				color: "red",
				cursor: "pointer",
			}}
		>
			{isLoading ? t("removing") + "..." : t("remove_group")}
		</button>
	);
};
